export default __webpack_public_path__ + "static/0145-832a08d96aa00796542f9860c7b8fc94.png";